import { computed } from 'vue';
<!-- Display a file size in a pretty/consistent way -->
<script lang="ts" setup>
    import { computed } from 'vue';

    const props = defineProps<{
        bytes?: number
    }>();

    const fileSize = computed<FileSizeModel | undefined>(()=>{
        if (!props.bytes)
            return undefined;

        const sizeMB = props.bytes / (1024 * 1024);
        if (sizeMB >= 1)
            return new FileSizeModel(sizeMB.toFixed(2), "MB");

        return new FileSizeModel((props.bytes / 1024).toFixed(2), "KB");
    });

    class FileSizeModel {
        size: string;
        sizeType: string;

        constructor(size: string, sizeType: string){ 
            this.size = size;
            this.sizeType = sizeType;
        }
    }
</script>

<template>
    <span v-if="fileSize">
        {{fileSize.size}} 
        <small>
            <small class="text-muted">
                {{fileSize.sizeType}}
            </small>
        </small>
    </span>
    <span v-else>
        <slot name="empty-file">---</slot>
    </span>
</template>